// value format = MMMM dd - MMMM dd
export function getRealRange(value = '') {
  const dates = value?.split('-');
  const startDate = dates?.[0]?.trim() || '';
  const endDate = dates?.[1]?.trim() || '';

  const showOnlyStartDate = !endDate || startDate === endDate;

  return showOnlyStartDate ? startDate : value;
}
